import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import securityIcon from '../assets/security-camera.png';
import Pc from '../assets/settings.png';
import Web from '../assets/application.png';
export default function Home() {
  return (
    <section className='hero'>

   

      <div className='container hero-grid'>

        {/* LEFT CONTENT */}
        <div>
          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6 }}
            className='hero-title'
          >
            Smart Tech Solutions for Security, Repairs & Web Innovation
          </motion.h1>

          <motion.p
            initial={{ y: 10, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className='hero-sub'
          >
           Got a tech issue? From security to repairs to websites — we fix it, build it and protect it.

  Whether your device is broken, your property needs protection, or your business needs a website — we’ve got you covered.
          </motion.p>

          <div className='cta-group'>
            <Link to='/contact' className='btn btn-primary'>Get Started</Link>
            <Link to='/services' className='btn btn-ghost'>Our Services</Link>
          </div>

          {/* SERVICES */}
          <div className='services'>
            <div style={{ marginTop: 22, color: '#cfe0ff' }}>Our core offerings</div>

            <div className='services-grid'>


              {/* CCTV ICON */}
              <div className='card'>
               
                <div className='icon-wrapper'>
  <img src={securityIcon} alt="CCTV icon" className="service-icon-img" />
</div>

                
                <h4>CCTV Sales & Install</h4>
                <p>Site surveys, camera selection & maintenance plans.</p>
              </div>


              {/* LAPTOP ICON */}
              <div className='card'>
                          
              <div className='icon-wrapper'>
  <img src={Pc} alt="CCTV icon" className="service-icon-img" />
</div>

                <h4>Laptop & PC Repair</h4>
                <p>Data recovery, component replacement & performance tuning.</p>
              </div>


              {/* WEB DEV ICON */}
              <div className='card'>
                            
              <div className='icon-wrapper'>
  <img src={Web} alt="CCTV icon" className="service-icon-img" />
</div>

                <h4>Web Development</h4>
                <p>Websites, e-commerce & full-stack systems.</p>
              </div>


            </div>
          </div>
        </div>

        {/* RIGHT IMAGE */}
        <motion.aside
          initial={{ scale: 0.98, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6 }}
          className='hero-illustration'
        >
          <img src='/hero-illustration.png' alt='illustration' />
        </motion.aside>

      </div>
    </section>
  );
}
